import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { debounce, throttle } from 'lodash';
import utilities from './../../../utils/utilities';
import utils from './../../../utils/utilities';

export default function withFixedHeader(CollectionComponent) {
    class FixedHeader extends Component {
        static propTypes = {
            fullScreen: PropTypes.bool
        }

        static defaultProps = {
            fullScreen: true
        }

        constructor(props) {
            super(props);
            this.container = null;
            this.tableWrapper = null;
            this.table = null;
            this.listening = false;
            this.state = {
                fixedHeader: false,
                headerWidth: null
            }
            this.updateHeaderWidth = this.updateHeaderWidth.bind(this);
            this.scrollEvent = this.scrollEvent.bind(this)
        }

        componentDidMount() {
            this.listenToScroll();
            this.updateHeaderWidth();
            this.scrollEvent();
            window.addEventListener('resize', this.updateHeaderWidth);
            this._isMounted = true;
        }

        componentDidUpdate() {
            this.listenToScroll();
        }

        componentWillUnmount() {
            if (this.listening && this.container) {
                this.container.removeEventListener('scroll', this.scrollEvent); // unmount event listener
            }
            window.removeEventListener('resize', this.updateHeaderWidth);
            this._isMounted = false;
        }

        updateHeaderWidth() {
            this.setState({headerWidth: this.table.getBoundingClientRect().width});
        }

        /**
         * Adds listener to scroll event, adds the event to the appropriate container
         */
        listenToScroll() {
            if (!this.listening && this.tableWrapper) {
                if (this.props.fullScreen) {
                    this.container = window
                } else {
                    this.container = this.tableWrapper
                }
                this.container.addEventListener('scroll', this.scrollEvent);
                this.listening = true;
            }
        }

        /**
         * Throttled function to calculate fixed header position
         * @type {Function}
         */
        calculateHeaderPosition = throttle(() => {
            const isFixedHeader = !utils.isElementTopInViewport(this.table);
            if (this.props.fullScreen && this.state.fixedHeader !== isFixedHeader) {
                this.setState({ fixedHeader: isFixedHeader })
            }
        });

        /**
         * Calls debounced function, sets fixed header state
         */
        scrollEvent() {
            this.calculateHeaderPosition();
        }

        render() {
            return (
                <div className={"scrollable " + (!this.props.fullScreen ? "inner" : "")}>
                    <div className={"scrollable-table " + (this.props.fullScreen ? "full-screen" : "")} ref={(el) => this.tableWrapper = el }>
                        <div className="scrollable-wrap" ref={(el) => this.table = el }>
                            <CollectionComponent {...this.props}
                                                 className={this.props.className + (this.state.fixedHeader ? " fixed" : "")}
                                                 headerWidth={this.state.headerWidth}/>
                        </div>
                    </div>
                </div>
            )
        }
    }

    FixedHeader.displayName = `withFixedHeader(${utilities.getDisplayName(CollectionComponent)})`;
    return FixedHeader;
}



// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/hoc/withFixedHeader.jsx